/**
 * Copyright IBM Corp. 2016, 2020
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */
import { CardGroup } from '../CardGroup';
import ContentBlock from '../../internal/components/ContentBlock/ContentBlock';
import ddsSettings from '@carbon/ibmdotcom-utilities/es/utilities/settings/settings';
import React from 'react';
import settings from 'carbon-components/es/globals/js/settings';
var stablePrefix = ddsSettings.stablePrefix;
var prefix = settings.prefix;
/**
 * Content Block - Cards pattern.
 */

var ContentBlockCards = function ContentBlockCards(_ref) {
  var heading = _ref.heading,
      cards = _ref.cards,
      cta = _ref.cta;
  return React.createElement("div", {
    "data-autoid": "".concat(stablePrefix, "--content-block-cards"),
    className: "".concat(prefix, "--content-block-cards")
  }, React.createElement(ContentBlock, {
    heading: heading,
    cta: cta
  }, React.createElement("div", {
    className: "".concat(prefix, "--content-block-cards__content")
  }, React.createElement(CardGroup, {
    cards: cards
  }))));
};

export default ContentBlockCards;